module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av325-cd74582c22b331b44087aaf4f1b56554.jpg";